import request from '@/plugins/axios'

export const apiInvoiceLists = (params: any) => request.get('/order.invoice/lists', { params })
export const apiInvoiceDetail = (params: any) => request.get('/order.invoice/detail', { params })
export const apiInvoiceExport = (params: any) => request.get('/order.invoice/export', { params })
